import { useEffect } from "react";
import { resolveEmojiShortcodes } from "@/lib/standard-emojis";

/** The root layout's title, used for any route that sets none of its own. */
const FALLBACK_TITLE = "Theta";

/** Sets document.title to "suffix | Theta" (or just "Theta" if no suffix). */
export function useTitle(suffix?: string | null) {
  useEffect(() => {
    const title = suffix ? `${resolveEmojiShortcodes(suffix)} | Theta` : FALLBACK_TITLE;
    document.title = title;

    // Next streams route metadata separately from the page, so React commits
    // its hoisted <title> *after* this effect has run — which is how tab names
    // ended up stuck on the layout's generic "Theta". Re-apply when that
    // happens, but only over the fallback: a route with its own metadata title,
    // or the next route mid-navigation, still gets to win.
    const observer = new MutationObserver(() => {
      if (document.title === FALLBACK_TITLE && title !== FALLBACK_TITLE) {
        document.title = title;
      }
    });
    observer.observe(document.head, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [suffix]);
}
